import { render } from "./milestone-level-navigation.vue?vue&type=template&id=2fa193d0&ts=true"
import script from "./milestone-level-navigation.vue?vue&type=script&lang=ts"
export * from "./milestone-level-navigation.vue?vue&type=script&lang=ts"

import "./milestone-level-navigation.vue?vue&type=style&index=0&id=2fa193d0&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__